import { useTranslation } from 'react-i18next';

import { isApiError } from '@/shared/api';
import { useErrorMessage } from '@/shared/i18n';

import styles from './states.module.css';

interface ErrorStateProps {
  error: unknown;
  onRetry?: () => void;
}

/** Standard inline error block. Shows the request ID to help support/debugging. */
export function ErrorState({ error, onRetry }: ErrorStateProps) {
  const { t } = useTranslation();
  const getMessage = useErrorMessage();
  const requestId = isApiError(error) ? error.requestId : null;
  return (
    <div className={styles.state} role="alert">
      <p className={styles.message}>{getMessage(error)}</p>
      {requestId && <code className={styles.requestId}>{requestId}</code>}
      {onRetry && (
        <button type="button" className={styles.retry} onClick={onRetry}>
          {t('common.retry')}
        </button>
      )}
    </div>
  );
}
